import "core-js/modules/es6.regexp.replace.js";
import Vue from 'vue';

// Registrato una volta per processo, a livello di modulo: in SSR Quasar esegue la funzione di boot
// a ogni richiesta, e un Vue.mixin globale ripetuto duplica i watch di ogni componente.
Vue.mixin({
  computed: {
    isMobile: function isMobile() {
      return this.$q.screen.lt.sm;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.back();
    },
    parsePhoneNumber: function parsePhoneNumber(phoneNumber) {
      // keep only digits and plus sign
      return phoneNumber.replace(/[^\d+]/g, '');
    }
  }
});
export default (function () {});